/*!


*/
import React, {useState, useEffect} from "react";
//import myimg from './logoccP.png';
import axios from 'axios'
import jwtDecode from "jwt-decode";
import {  useLocation ,useNavigate , useHistory} from 'react-router-dom';
import { dtStamp } from './stamp';
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Label,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  Row,
} from "reactstrap";

function Login() {
  let history = useHistory();
  const [name , setName ] = useState()
  const [pass , setPass ] = useState()
  const [msg, setMsg] = useState()

  React.useEffect(() => {
    document.body.classList.toggle("login-page");
    return function cleanup() {
      document.body.classList.toggle("login-page");
    };
  });

  const auth = () => {
    setMsg("")
    let browsername = dtStamp().browsername;
    let localdt = dtStamp().localdt;
    axios.post(`${process.env.REACT_APP_APIURL}/ten/rnmusr`, {email : name, pass : pass, browsername, localdt, typeIs : "Tenant" })
    .then(res => {
      localStorage.setItem("arixauth" , res.headers.arixauth)
      //console.log('headers are set')
    }).then(t => {
     
      nonotpwindow()

    })
    .catch(e =>{
        console.log(e)
        try{
          if(e.response.status === 404) {
            setMsg("Incorrect Login ID")  
          }
          else if(e.response.status === 401) {
            setMsg("invalid user or password")  
          }else{
            setMsg(e.response.data.message)
          }
        }catch(ss){
       
          setMsg("Catch Block!")
        }

    });
  }

  const nonotpwindow = () => {
  //  window.location.reload(false)
    history.push("/tenant/dashboard")
    // window.location.reload(false)
  }

  return (
    <div className="login-page">
      <Container>
      <center>
        <Row style={{justifyContent : "center"}}>
          <Col className="ml-auto mr-auto" lg="4" md="6" >
            
            <Form action="" className="form" method="" >
              <Card className="card-login">
                <CardHeader>
                  <CardHeader>
                    <h3 className="header text-center">Login</h3>
                  </CardHeader>
                </CardHeader>
                <CardBody>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="nc-icon nc-single-02" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input placeholder="email" type="text" value={name}  onChange={e => setName(e.target.value.trim())}/>
                  </InputGroup>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="nc-icon nc-key-25" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Password"
                      type="password"
                      autoComplete="off"
                      value={pass}
                      onChange={e => setPass(e.target.value)}
                    />
                  </InputGroup>
                  <br />
                  <FormGroup>
                    <FormGroup check>
                    <center>
                    <span> VNM Rental, Tenant portal version 1.0</span>
                    </center>
                    </FormGroup>
                  </FormGroup>
                </CardBody>
                <CardFooter>
                  <Button
                    block
                    className="btn-round mb-3"
                    color="warning"
                    href="#pablo"
                    onClick={(e) => auth()}
                  >
                    Get Started
                </Button>
                <center>{msg}</center>
                </CardFooter>
              </Card>
            </Form>
            
          </Col>
        </Row>
        </center>
      </Container>
      
    </div>
  );
}

export default Login;
